// extracted by mini-css-extract-plugin
export default {"tooltip":"Ds-z","sharingV2":"Es-z","sharingIconsV2":"Fs-z","links":"Gs-z","link":"Hs-z","facebookV2":"Is-z","twitterV2":"Js-z","pinterestV2":"Ks-z"};